"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  IS_ACCEPTED: 'isAccepted',
  IS_ABN: 'isAbn',
  IS_ACN: 'isAcn',
  IS_ALPHANUMERIC: 'isAlphaNumeric',
  IS_DATE_AFTER: 'isDateAfter',
  IS_DATE_BEFORE: 'isDateBefore',
  IS_DATE_EQUAL_TO_OR_AFTER: 'isDateEqualToOrAfter',
  IS_DATE_EQUAL_TO_OR_BEFORE: 'isDateEqualToOrBefore',
  IS_DECIMAL: 'isDecimal',
  IS_EMAIL: 'isEmail',
  IS_EMPTY: 'isEmpty',
  IS_IN_RANGE: 'isInRange',
  IS_INT: 'isInt',
  IS_LENGTH: 'isLength',
  IS_LOCAL_PHONE: 'isLocalPhone',
  IS_MATCH: 'isMatch',
  IS_MATCH_SI: 'isMatchSi',
  IS_NOT_GREATER_THAN: 'isNotGreaterThan',
  IS_NUMERIC: 'isNumeric',
  IS_NOT_EQUAL_TO: 'isNotEqualTo',
  IS_PASSWORD: 'isPassword',
  IS_PASSWORD_MATCH: 'isPasswordMatch',
  IS_PHONE: 'isPhone',
  IS_VALID_DATE: 'isValidDate',
  IS_VALID_TIME: 'isValidTime',
  IS_DATE_IN_PAST: 'isDateInPast',
  IS_DATE_WITHIN_NUM_YEARS: 'isDateWithinNumYears',
  IS_DATE_WITHIN_NUM_MONTHS: 'isDateWithinNumMonths',
  IS_DATE_WITHIN_NUM_DAYS: 'isDateWithinNumDays',
  IS_STRUCTURED_ADDRESS: 'isStructuredAddress'
};
exports.default = _default;
//# sourceMappingURL=ConfigFormValidators.js.map